import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  DialogActions,
  Grid,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import CustomInput from "../../../../../../Components/CustomInput";
import DateComponent from "../../../../../../Components/FormGenerator/datepicker_component";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
  },
  errorLog: {
    color: "#ff0000",
  },
  title: {
    textTransform: "none",
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "97%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #3B86FF",
    },
  },
}));

interface IProps {
  isOpen: any;
  onClose(): void;
  setNewInputState: any;
  activityData: any;
  errorLogs: any;
  onsubmit: any;
  addToProgram: boolean;
  selection?: any;
}

const ActivityLogModal: (props: IProps) => JSX.Element = (props: IProps) => {
  const {
    isOpen,
    onClose,
    setNewInputState,
    activityData,
    errorLogs,
    onsubmit,
    addToProgram,
    selection,
  } = props;

  const classes = useStyles();

  return (
    <>
      <Dialog
        fullWidth={true}
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="base-station-manage"
      >
        <form spellCheck="false">
          <DialogTitle id="customized-dialog-title">
            <Typography variant="subtitle1">
              Add activity log - {selection?.name}
            </Typography>
          </DialogTitle>
          <Divider />
          <DialogContent style={{ margin: "10px" }}>
            <div className={classes.formWrapper}>
              <div>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Activity name
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <CustomInput
                        id="activity_name"
                        variant="outlined"
                        placeholder="Activity name"
                        parentcall={setNewInputState}
                        value={activityData.activity_name}
                      />
                      {errorLogs?.activity_name ? (
                        <span className={classes.errorLog}>
                          Activity name is required.
                        </span>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid
                    item
                    xs={3}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Typography variant="h2" className={classes.title}>
                      Date
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <DateComponent
                      key={"1235"}
                      componentObject={{
                        componentType: "datePicker",
                        required: true,
                        name: "date",
                        placeholder: "Date",
                        helperText: false,
                        indexKey: "0-212",
                        index: "date",
                        handleChange: setNewInputState,
                        value: activityData?.date,
                        customStyle: { marginBottom: "2px" },
                      }}
                    />
                    {errorLogs?.date ? (
                      <span className={classes.errorLog}>
                        Date is required.
                      </span>
                    ) : null}
                  </Grid>
                </Grid>
                <Grid container spacing={1} justify={"flex-start"}>
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Comments
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <CustomInput
                      id="comments"
                      multiline
                      rows="4"
                      variant="outlined"
                      placeholder="Comments"
                      parentcall={setNewInputState}
                      value={activityData.comments}
                    />
                  </Grid>
                </Grid>
                {addToProgram && (
                  <Grid container spacing={1} justify={"flex-start"}>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={9}>
                      <FormControlLabel
                        label="Add to Program"
                        style={{ marginRight: "10px", marginTop: "10px" }}
                        control={
                          <Checkbox
                            checked={activityData?.addToPrograms}
                            onChange={(event) => {
                              setNewInputState(
                                event.target.checked,
                                "addToPrograms"
                              );
                            }}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => onClose()}
              disableElevation
              type="button"
              style={{ textTransform: "capitalize" }}
              variant={"contained"}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              onClick={onsubmit}
              style={{ textTransform: "capitalize" }}
              variant={"contained"}
              color="secondary"
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
export default ActivityLogModal;
